import React, {useState} from "react";
import "./publicationFacet.scss";
import {Collapse, FormCheck, ToggleButton} from "react-bootstrap";
import i18next from "../../../../i18n";
import FormCheckInput from "react-bootstrap/FormCheckInput";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";

function _get_facet_name(facet_key) {
    const _facet_lookup = {
        'series': i18next.t('publications_facets.series', 'Series'),
        'recurrence_supplement': i18next.t('publications_facets.supplement', 'Supplement'),
        'recurrence_addendum': i18next.t('publications_facets.addendum', 'Addendum'),
        'recurrence_amendment': i18next.t('publications_facets.amendment', 'Amendment'),
        'recurrence_revision': i18next.t('publications_facets.revision', 'Revision'),
        'recurrence_volume': i18next.t('publications_facets.volume', 'Volume'),
        'recurrence_issue': i18next.t('publications_facets.issue', 'Issue'),
        'recurrence_part': i18next.t('publications_facets.part', 'Part'),
        'recurrence_number': i18next.t('publications_facets.number', 'Number'),
        'recurrence_session': i18next.t('publications_facets.session', 'Session'),
        'recurrence_year': i18next.t('publications_facets.year', 'Year'),
        'recurrence_year_range': i18next.t('publications_facets.year_range', 'Year Range'),
        'recurrence_edition': i18next.t('publications_facets.edition', 'Edition'),
        'recurrence_symbol': i18next.t('publications_facets.symbol', 'Symbol'),
        'authors': i18next.t('publications_facets.authors', 'Authors'),
        'publishers': i18next.t('publications_facets.publishers', 'Publishers'),
        'publication_date': i18next.t('publications_facets.publication_date', 'Publication Date'),
        'theme_nuclear_disarmament_non_proliferation': i18next.t('publications_facets.nuclear_disarmament_non_proliferation', 'Nuclear Disarmament and Non-Proliferation'),
        'theme_biological_chemical_weapons': i18next.t('publications_facets.biological_chemical_weapons', 'Biological and Chemical Weapons'),
        'theme_conventional_weapons': i18next.t('publications_facets.conventional_weapons', 'Conventional Weapons'),
        'theme_regional_disarmament': i18next.t('publications_facets.regional_disarmament', 'Regional Disarmament'),
        'theme_emerging_cross_cutting_other_issues': i18next.t('publications_facets.emerging_crosscutting_issues', 'Emerging Cross-Cutting Issues'),
        'theme_gender_perspectives_disarmament_arms_control': i18next.t('publications_facets.gender_perspectives', 'Gender perspectives on disarmament and arms control'),
        'theme_disarmament_machinery': i18next.t('publications_facets.disarmament_machinery', 'Disarmament Machinery'),
        'theme_information_outreach': i18next.t('publications_facets.information_outreach', 'Information Outreach'),
    }
    return _facet_lookup[facet_key]
}

function _get_facet_value(facet_value) {
    const _val_lookup = (val) => {
        const _lookup = {
            'occasional_papers': i18next.t('publications.unoda_occasional_papers', 'UNODA Occasional Papers'),
            'disarmament_study_series': i18next.t('publications.disarmament_study_series', 'Disarmament Study Series'),
            'civil_society': i18next.t('publications.civil_society_disarmament', 'Civil Society and Disarmament'),
            'basic_guide': i18next.t('publications.disarmament_basic_guide', 'Disarmament: A Basic Guide'),
            'disarmament_res_dec': i18next.t('publications.disarmament_resolutions_decisions', 'Disarmament Resolutions and Decisions of the United Nations General Assembly'),
            'disarmament_crit_issues': i18next.t('publications.critical_disarmament_issues', 'Critical Disarmament Issues'),
            'yearbook': i18next.t('publications.disarmament_yearbook', 'Disarmament Yearbook'),
            'prog_fin_vol_contribs': i18next.t('publications.progs_financed_voluntary_contributions', 'Programmes Financed from Voluntary Contributions'),
            'other_pubs': i18next.t('publications.other_publications', 'Other Publications'),
        }
        return Object.keys(_lookup).includes(val) ? _lookup[val] : val
    }

    return _val_lookup(facet_value)
}

const PublicationFacet = ({ facet, onFacetChange }) => {
    const {facetKey, facetList} = facet;
    const [open, setOpen] = useState(false);

    const _toggleFacet = (facet_key, facet_entry) => {
        const selected = !facet_entry.selected;
        const facetChangeEvent = {
            facet_key,
            facet_entry: {...facet_entry, selected}
        }
        onFacetChange(facetChangeEvent)
    }

    const FACET_LIMIT = 5;

    return (
        <>
            <div className="faceted-filter">
            <div className="py-3 bg-soft-dark">
                <h5 className="mb-0 header-accent header-accent-start">{_get_facet_name(facetKey)}</h5>
            </div>
            {facetList.slice(0, FACET_LIMIT).map((facet_entry, index) => {
                const {facet, count, selected} = facet_entry;
                return (
                    <>
                        <FormCheck
                            id={facet + '-' + index}
                            className={'d-flex flex-row'}
                            type={"checkbox"}>
                            <FormCheckInput
                                type={"checkbox"}
                                checked={selected}
                                onChange={() => _toggleFacet(facetKey, facet_entry)}
                            />
                            <FormCheckLabel className={'d-flex flex-row justify-content-between w-100'}>
                                <div className={"fs-xs"}>{_get_facet_value(facet)}</div>
                                <div className={"fs-xs fw-medium"}>({count})</div>
                            </FormCheckLabel>
                        </FormCheck>
                    </>
                )
            })}
            {facetList.length > 5 &&
                <Collapse in={open}>
                    <div id={"collapse-" + facetKey} className="facets-list my-0">
                        {facetList.slice(5, facetList.length).map((facet_entry, index) => {
                            const {facet, count, selected} = facet_entry;
                            return (
                                <>
                                    <FormCheck
                                        id={facet + '-' + index}
                                        className={'d-flex flex-row'}
                                        type={"checkbox"}>
                                        <FormCheckInput
                                            type={"checkbox"}
                                            checked={selected}
                                            onChange={() => _toggleFacet(facetKey, facet_entry)}/>
                                        <FormCheckLabel className={'d-flex flex-row justify-content-between w-100'}>
                                            <div className={"fs-xs"}>{_get_facet_value(facet)}</div>
                                            <div className={"fs-xs fw-medium"}>({count})</div>
                                        </FormCheckLabel>
                                    </FormCheck>
                                </>
                            )
                        })}
                    </div>
                </Collapse>
            }
            {facetList.length > FACET_LIMIT &&
                <a className="btn pt-0 color-black-75" role="button" aria-expanded={open} aria-controls={"collapse-" + facetKey} onClick={() => setOpen(!open)}>
                    {open ? i18next.t('publications.show_less', "show less") : i18next.t('publications.show_more', "show more")}
                    {open ? <i className="ml-sm bi bi-dash-square"></i> : <i className="ml-sm bi bi-plus-square"></i>}
                </a>
            }
        </div>
        </>
    )
}

export default PublicationFacet;
